function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#647A97",
  strokeWidth: 1.5,
  d: "M15.302 1.083a.28.28 0 01.281.28h0v13.94a.279.279 0 01-.28.28h0H1.364a.28.28 0 01-.281-.28h0V1.364a.28.28 0 01.083-.198h0z"
});

function SvgHappyUncheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17"
  }, props), _ref);
}

export default SvgHappyUncheck;